import React, { Component } from 'react';
import { CSVLink } from "react-csv";
import axios from 'axios'
import dayjs from 'dayjs';
import { FormattedMessage  } from 'react-intl';

//import {TrimNan} from '../utils/utils'
import LoadingControl from '../controls/Loading';
import DownloadButton from '../controls/DownloadButton';
import DeviceCounters from '../controls/DeviceCounters';
import '../App.css';

class DeviceMetersPane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: null,
      csvData: []
    };
  }

  async getData() {
    let maxDate = new Date();
    const res = await axios("/printer?sort=prnName&start=1&end=" + Math.round(maxDate.getTime() / 1000));
    return res.data;
  }

  update() {
    this.setState({isLoaded: false});

    this.getData()
    .then(res => {
      this.setState({ error: null, isLoaded: true, items: res });
    })
    .catch(err => {
      console.log(err);
      this.setState( {error: err, isLoaded: false, items: null });
    });
  }  

  componentDidMount() {
    this.update();
  }

  onCSVExportClick()
  {
    this.setState({ csvData: this.state.items }, () => {
      // click the CSVLink component to trigger the CSV download
      this.csvLink.link.click()}
    );
  }
  
  render() {
      if(this.state.error != null)
      {
        return (
          <div><h3>{this.state.error.message}</h3></div>
        );
      }
      else if (!this.state.isLoaded)
      {
        return (
          <div><LoadingControl/></div>
        );
      }
      else
      {
        return (
          <div>
            <div className = "history-pane-header">
              <div className = "range-picker"><b><FormattedMessage id="LeftMenu.device_meters"/>:</b>  {dayjs().format("YYYY-DD-MM HH:mm")}</div>
              <CSVLink 
                data={this.state.csvData}
                separator=";"
                ref={(r) => this.csvLink = r}
                filename="device_meters.csv"
                className="hidden"
                target="_blank">                
                </CSVLink>
              <DownloadButton onCSVExport = {() => {this.onCSVExportClick()}}/>
              <DeviceCounters data = {this.state.items}/>
              </div>
          </div>
        );
      }
  }
}

export default DeviceMetersPane;